import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import myphoto from './myphoto/Yeni.JPG';
import Balloons from './Balloons';
import './App.css';
import bookCover1 from './myphoto/Book1.jpg';
import bookCover2 from './myphoto/Book2.jpg';
import powerbi from './myphoto/powerbi1.png';
import python from './myphoto/python_append.png';
import ddImage from './myphoto/dd.png';


function Home() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const goTo = (newIndex) => {
    setDirection(newIndex > index ? 1 : -1);
    setIndex(newIndex);
  };

  const nextSlide = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % sections.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setIndex((prev) => (prev - 1 + sections.length) % sections.length);
  };

  const sections = [
    {
      id: 'home',
      label: 'Home',
      content: (
        <div className="section-content home-content">
          <img
            src={myphoto}
            alt="Yeni Waliatin"
            className="profile-image animated-profile"
          />
          <h1 className="hero-heading">
            Hi, I'm <span className="highlight-name">Yeni Waliatin</span> 👩‍💻
          </h1>
          <p className="hero-subtitle">
            🎓 IT Graduate from Deakin University<br />
            📊 Data Analyst | 📈 Dashboard Creator | ⚛️ React Enthusiast
          </p>
          <div className="hero-buttons">
            <button
              className="hero-btn"
              onClick={() => goTo(sections.findIndex(s => s.id === 'projects'))}
            >
              See My Projects
            </button>
            <button
              className="hero-btn secondary"
              onClick={() => goTo(sections.findIndex(s => s.id === 'contact'))}
            >
              Contact Me
            </button>
          </div>
        </div>
      )
    },
    {
      id: 'about',
      label: 'About',
      content: (
        <div className="section-content">
          <h2>👩‍💻 About Me</h2>
          <p>
            I'm a passionate and results-driven <strong>data professional</strong> with hands-on experience in transforming raw data into meaningful insights.
          </p>
          <ul style={{ marginLeft: '1.5rem' }}>
            <li>📊 Data analysis, cleaning, and visualization</li>
            <li>🛠️ Tools: Excel, SQL, Python, Power BI, Tableau, R, Smartsheet</li>
            <li>📈 Dashboard building and automation</li>
            <li>🤝 Stakeholder engagement and collaboration</li>
          </ul>
          <p>In recent roles at the <strong>Department of Education</strong> and the <strong>Department of Justice and Community Safety</strong>:</p>
          <ul style={{ marginLeft: '1.5rem' }}>
            <li>🎓 Student attendance and mobility data</li>
            <li>📚 Koorie education initiatives</li>
            <li>📍 Public service delivery and racism reporting</li>
          </ul>

          <p>Academic Projects:</p>
          <ul style={{ marginLeft: '1.5rem' }}>
            <li>🧹 Data Wrangling using Python, Power BI, Tableau
            Prepared, cleaned, and visualized data for an analytical report.</li>
            <li>🚚 Truck Sharing Application using Android Studio, Java, Firebase, SQL, and Web APIs
            Planned, designed, and developed an interactive and visually appealing website.</li>
            
          </ul>

          <p>🎓 <strong>Education:</strong><br /> - Bachelor of IT, Deakin University<br /> - Diploma in Informatics, STMIK Cikarang</p>
        </div>
      )
    },
    {
      id: 'projects',
      label: 'Projects',
      content: (
        <div className="section-content">
          <h2>Projects</h2>
          <p>These projects are sample pieces included in my portfolio to showcase my skills:</p>
          <ul>
            
            <li>
  <a
    href="https://app.powerbi.com/groups/me/reports/f5fe2be2-284f-4d19-9dea-f84ff2506240/7c168b146ce07906c949?experience=power-bi"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: 'black' }} // Optional styling
  >
    <div>
      <strong style={{ color: '#0645AD', textDecoration: 'underline' }}>Power BI Education Dashboard – Student Absence Dashboard</strong><br />
      <img
        src={powerbi}
        alt="Power BI Dashboard"
        width="300"
        height="170"
        style={{ borderRadius: '8px', boxShadow: '0 0 6px rgba(0,0,0,0.2)', marginTop: '5px' }}
      />
    </div>
  </a>
</li>

            
            <li>
  <a
    href="https://github.com/ywaliatin/Append_Files_Python"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: 'black' }}
  >
    <div>
      <strong style={{ color: '#0645AD', textDecoration: 'underline' }}>Python Excel Automation – Appending Excel Files Based on Matching Column Names</strong><br />
      <img
        src={python}
        alt="Python Excel Project"
        width="300"
        height="170"
        style={{ borderRadius: '8px', boxShadow: '0 0 6px rgba(0,0,0,0.2)', marginTop: '5px' }}
      />
    </div>
  </a>
</li>

<li>
  <a
    href="https://dinikdelavega.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: 'black' }}
  >
    <div>
      <strong style={{ color: '#0645AD', textDecoration: 'underline' }}>
        React.js – Frontend Website
      </strong><br />
      <img
        src={ddImage}
        alt="React Frontend Thumbnail"
        width="300"
        height="170"
        style={{
          borderRadius: '8px',
          boxShadow: '0 0 6px rgba(0,0,0,0.2)',
          marginTop: '5px'
        }}
      />
    </div>
  </a>
</li>


<li>
  <div>
    <strong style={{ color: '#0645AD', textDecoration: 'underline' }}>Videography and Video Editing – Cleland Adelaide Wildpark</strong><br />
    <iframe
      width="300"
      height="170"
      src="https://www.youtube.com/embed/HxJwQhu6oQ0"
      title="Video Editing Example 1"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      style={{ marginTop: '5px', borderRadius: '8px', boxShadow: '0 0 6px rgba(0,0,0,0.2)' }}
    ></iframe>
  </div>
</li>

<li>
  <a
    href="https://www.amazon.com.au/dp/B0FCM9LCGS"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: 'black' }}
  >
    <div>
      <strong style={{ color: '#0645AD', textDecoration: 'underline' }}>Canva Children's Book – Real Friends Stay Forever</strong><br />
      <img
        src={bookCover1}
        alt="Children's Book 1"
        width="300"
        height="170"
        style={{ borderRadius: '8px', boxShadow: '0 0 6px rgba(0,0,0,0.2)', marginTop: '5px' }}
      />
    </div>
  </a>
</li>

<li>
  <a
    href="https://www.amazon.com.au/dp/B0FD8XBXRG"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: 'black' }}
  >
    <div>
      <strong style={{ color: '#0645AD', textDecoration: 'underline' }}>Canva Children's Book – Potty Training</strong><br />
      <img
        src={bookCover2}
        alt="Children's Book 2"
        width="300"
        height="170"
        style={{ borderRadius: '8px', boxShadow: '0 0 6px rgba(0,0,0,0.2)', marginTop: '5px' }}
      />
    </div>
  </a>
</li>

          </ul>
        </div>
      )
    },
    {
      id: 'contact',
      label: 'Contact',
      content: (
        <div className="section-content contact-section fancy-border">
          <h2>Contact Me</h2>
          <p>
            📧 Email:{' '}
            <a href="mailto:yeni.waliatin@gmail.com" className="contact-link">
              yeni.waliatin@gmail.com
            </a>
          </p>
          <p>
            🔗 LinkedIn:{' '}
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="contact-link"
            >
              Visit my LinkedIn
            </a>
          </p>
        </div>
      )
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setIndex((prev) => (prev + 1) % sections.length);
    }, 120000);

    return () => clearInterval(timer);
  }, [sections.length]); // ✅ fixes warning

  return (
    <div className="home-wrapper">
      {/* Top Menu */}
      <nav className="top-nav">
        {sections.map((section, i) => (
          <button
            key={section.id}
            className={`nav-link ${index === i ? 'active' : ''}`}
            onClick={() => goTo(i)}
          >
            {section.label}
          </button>
        ))}
      </nav>

      <Balloons />

      {/* Slide Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={sections[index].id}
          initial={{ x: direction > 0 ? 300 : -300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: direction > 0 ? -300 : 300, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="slide-container"
        >
          {sections[index].content}
        </motion.div>
      </AnimatePresence>

      {/* Arrows */}
      <div className="arrow-nav">
        <button onClick={prevSlide} className="arrow-btn">⬅️</button>
        <button onClick={nextSlide} className="arrow-btn">➡️</button>
      </div>
    </div>
  );
}

export default Home;
